import React, { useEffect, useState } from "react";
import { FaBars } from 'react-icons/fa'
import { Navb, NavContainer, NavLogo, MobileIcon, NavMenu, NavItem, NavLinks } from "./NavStyled";
import { animateScroll as scroll } from "react-scroll/modules";

const Navbar = ({ toggle }) => {
    const [scrollLegal, setScrollLegal] = useState(false)

    const changeNav = () => {
        if (window.scrollY >= 80) {
            setScrollLegal(true)
        } else {
            setScrollLegal(false)
        }
    }
    useEffect(() => {
        window.addEventListener('scroll', changeNav);
    }, []);

    const toggleHome = () => {
        scroll.scrollToTop();
    }

    return (
        <>
            <Navb scrollLegal={scrollLegal}>
                <NavContainer>
                    <NavLogo to='/' onClick={toggleHome}>Curriculum João</NavLogo>
                    <MobileIcon onClick={toggle}>
                        <FaBars />
                    </MobileIcon>
                    <NavMenu>
                        <NavItem>
                            <NavLinks
                                to="sobre"
                                smooth={true}
                                duration={500}
                                spy={true}
                                exact='true'
                                offset={-80}
                                activeClass="active"
                            >Sobre mim</NavLinks>
                        </NavItem>
                        <NavItem>
                            <NavLinks
                                to="formacao"
                                smooth={true}
                                duration={500}
                                spy={true}
                                exact='true'
                                offset={-80}
                                activeClass="active"
                            >Formação</NavLinks>
                        </NavItem>
                        <NavItem>
                            <NavLinks
                                to="certificacao"
                                smooth={true}
                                duration={500}
                                spy={true}
                                exact='true'
                                offset={-80}
                                activeClass="active"
                            >Certificações</NavLinks>
                        </NavItem>
                        <NavItem>
                            <NavLinks
                                to="experiencia"
                                smooth={true}
                                duration={500}
                                spy={true}
                                exact='true'
                                offset={-80}
                                activeClass="active"
                            >Experiencia Profissional</NavLinks>
                        </NavItem>
                    </NavMenu>
                </NavContainer>
            </Navb>
        </>

    );
};

export default Navbar;